import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";

import {LoginService} from "app/login/login.service";
import {MeusLaudosCDModel} from "./meus-laudos-cd.model";

import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BasicValidators} from "../../shared/basic-validators";

import {ClientesLaudosCDService} from "./clientes-laudos-cd.service";
import {Components} from "../../shared/components/components";
import {Global} from "../../global";
import {Funcoes} from "../../funcoes";

declare let swal, $: any;

@Component({
  selector: 'app-meus-laudos-cd',
  templateUrl: './meus-laudos-cd.component.html'
})
export class MeusLaudosCDComponent extends Components implements OnInit {

  laudos: MeusLaudosCDModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};
  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"de":"", "ate":"", "container":"", "numero":""};

  formSolicitarFicha: FormGroup;
  solicitaFicha = {"id_ficha": null, "nome": "", "email": ""};
  processandoSolicitarFicha: boolean = false;

  listVisibilidades: any[] = [];
  clienteSelecionado: string = null;

  constructor(
    formBuilder: FormBuilder,
    private laudosService: ClientesLaudosCDService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    public loginService: LoginService
  ) {
    super();

    this.formPesquisaAvancada = formBuilder.group({
      de: [],
      ate: [],
      container: [],
      numero: []
    });

    this.formSolicitarFicha = formBuilder.group({
      id_ficha: ['', [
        Validators.required
      ]],
      nome: ['', [
        Validators.required
      ]],
      email: ['', [
        Validators.required,
        BasicValidators.email
      ]],
    });
  }

  ngOnInit() {
    this.laudosService.getVisibilidades().subscribe(
      json => {
        if (json && json.Success && json.Payload) {
          this.listVisibilidades = json.Payload;
        }
      },
      error => {
        console.error('Erro ao carregar visibilidades:', error);
      }
    );
    this.getPage(1);
  }

  selecionarAbaCliente(idCliente: string = null) {
    this.clienteSelecionado = idCliente;
    this.getPage(1);
  }

  formatNomeAba(nome: string): string {
    if (!nome) return '';
    return nome.length > 40 ? nome.substring(0, 40) + '...' : nome;
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.clienteSelecionado) {
      filtros['id_cliente'] = 'eq:' + this.clienteSelecionado;
    }

    if (this.filtroPesquisa.de != '' && this.filtroPesquisa.ate != '') {
      filtros['data_inspecao'] = 'bt:' + this.filtroPesquisa.de + ' 00:00:00|' + this.filtroPesquisa.ate + ' 23:59:59';
    } else {
      if (this.filtroPesquisa.de != '') {
        filtros['data_inspecao'] = 'ge:' + this.filtroPesquisa.de + ' 00:00:00';
      }
      if (this.filtroPesquisa.ate != '') {
        filtros['data_inspecao'] = 'le:' + this.filtroPesquisa.ate + ' 23:59:59';
      }
    }

    if(this.filtroPesquisa.container != ''){
      filtros['identificacao_transporte'] = "**:"+this.filtroPesquisa.container;
    }

    if(this.filtroPesquisa.numero != ''){
      filtros['numero'] = "**:"+this.filtroPesquisa.numero;
    }

    this.laudosService.getPaginacao(pagina, this.itensPorPagina, ['produto', 'unidade', 'terminal', 'status', 'exportador'], filtros)
      .subscribe(data => {
          this.laudos = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;

          if (this.global.debug) {
            console.log(this.laudos);
          }
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"de":"", "ate":"", "container":"", "numero":""};
  }

  changeContainer(e){
    this.filtroPesquisa.container = e.toUpperCase().replace(/_/g, '');
  }

  modalSolicitaFicha(id){
    this.solicitaFicha.id_ficha = id;
    this.processandoSolicitarFicha = false;
    $('#modalSolicitarFicha').modal('show');
  }

  solicitaFichaEmail(){
    this.processandoSolicitarFicha = true;
    this.laudosService.enviaPdfEmail(this.solicitaFicha.id_ficha, this.solicitaFicha)
      .subscribe(json => {
          this.processandoSolicitarFicha = false;
          $('#modalSolicitarFicha').modal('hide');
        },
        error => {
          this.processandoSolicitarFicha = false;
          this.func.showErro(error.json());
        });
  }

  baixarPdf(id) {
    this.carregandoTabela = true;
    this.laudosService.baixarZipPdf(id)
      .subscribe(
        json => {
          this.carregandoTabela = false;
          if (json && json.Success && json.Payload) {
            window.open(this.laudosService.dominio + json.Payload, '_blank');
          } else {
            swal("Erro", "Erro ao baixar PDF.", "error");
          }
        },
        error => {
          this.carregandoTabela = false;
          this.func.showErro(error.json());
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/area-cliente/meus-laudos-cd/meus-laudos-cd.component.ts